module.exports = __webpack_public_path__ + "static/media/garage-chapms-logo.0b680383.svg";